import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  Heading,
  LoaderIndicator,
  SelectionBox,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { getPeriods, IPeriod } from '@/modules/catalog/services/funds';


export default /*#__PURE__*/_defineComponent({
  __name: 'Period',
  setup(__props) {

const router = useRouter();

const updateData = inject(
  'updateData',
  (key: string, name: object, askForInvestorType: boolean) => ({
    key,
    name,
    askForInvestorType
  })
);

const selectedOption = ref('');
const isLoading = ref(true);
const periods = ref<IPeriod[] | null>(null);

const options = computed(() => {
  return periods.value?.map(item => {
    return {
      title: item.period.formatted,
      value: item.period.value
    };
  });
});

const selectedOptionFormatted = computed(() => {
  const data = periods.value?.filter(
    item => item.period.value === selectedOption.value
  );

  return data![0].period;
});

const askForInvestorType = computed(() => {
  const data = periods.value?.filter(
    item => item.period.value === selectedOption.value
  );

  return data![0].askForInvestorType;
});

const isDisabled = computed(() => {
  return !selectedOption.value;
});

function handleChangeOption(value: string) {
  selectedOption.value = value;
}

function onClick() {
  updateData('period', selectedOptionFormatted.value, askForInvestorType.value);
}

async function fetchPeriods() {
  try {
    isLoading.value = true;

    periods.value = await getPeriods();
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível carregar as informações. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });

    router.push({ name: 'catalog' });
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  await fetchPeriods();
});

return { __sfc: true,router, updateData, selectedOption, isLoading, periods, options, selectedOptionFormatted, askForInvestorType, isDisabled, handleChangeOption, onClick, fetchPeriods, Heading, LoaderIndicator, SelectionBox, ButtonContainer, ButtonPrimary }
}

})